module.exports = __webpack_public_path__ + "static/media/car.b91c7d8a.png";